import React from 'react';
import { Mutation } from 'react-apollo';
import { DocumentShape } from 'builder/Knowledge/types';
import workspaceService from 'services/WorkspaceService';
import KnowledgeMapDetailsDrawer from '../../components/KnowledgeMapDetailsDrawer';
import EditRootDrawer from '../../components/KnowledgeMapDetailsDrawer/EditRootDrawer';
import { Paper } from '../../components/KnowledgeMapDetailsDrawer/styles';
import competencyDocumentItemUpdateMutation from '../../queries/competencyDocumentItemUpdate';
import competencyDocumentUpdateMutation from '../../queries/competencyDocumentUpdate';
import { fragments, workspaceDocumentFragments } from '../../queries/getDocument';

function KnowledgeMapDetailsDrawerContainer({ knowledgeMap, knowledgeMapItem, isRootNodeSelected, ...props }) {
  
  const getMutationForRoot=()=>(
    <Mutation
      mutation={competencyDocumentUpdateMutation}
      update={(client, response) => {
        const {documentId, title} = response?.data?.competencyDocumentUpdate?.document;
        if(!documentId || !title) return ;
        const id = `Document:${documentId}`;
        const { document: documentFragment } = workspaceDocumentFragments;
        const existingDocument = client.readFragment({
          id,
          fragment: documentFragment,
        });
        client.writeFragment({
          id,
          fragment: documentFragment,
          data: {
            ...existingDocument,
            title,
            __typename: existingDocument.__typename,
          },
        });
      }}
    >
      {(competencyDocumentUpdate) => (
        <Paper {...props}>
          <EditRootDrawer
            {...props}
            key={knowledgeMap.id}
            knowledgeMap={knowledgeMap}
            onChangeItem={({ title }) => {
              competencyDocumentUpdate({
                variables: {
                  documentId: knowledgeMap.id,
                  workspaceId: workspaceService.getSelectedWorkspaceId(), 
                  title,
                },
              });
            }}
          />
        </Paper>
      )}
    </Mutation>
  );

  const getMutationForNonRoot=()=>(
    <Mutation
      mutation={competencyDocumentItemUpdateMutation}
      update={(client, { data: { CompetencyDocumentItemUpdate: { documentItem } } }) => {
        const id = `DocumentItem:${documentItem.id}`;
        const existingDocumentItem = client.readFragment({
          id,
          fragment: fragments.documentItem,
        });
        client.writeFragment({
          id,
          fragment: fragments.documentItem,
          data: {
            ...existingDocumentItem,
            ...documentItem,
            __typename: existingDocumentItem.__typename,
          },
        });
      }}
    >
      {(competencyDocumentItemUpdate) => (
        <Paper {...props}>
          <KnowledgeMapDetailsDrawer
            {...props}
            key={knowledgeMapItem.id}
            knowledgeMap={knowledgeMap}
            knowledgeMapItem={knowledgeMapItem}
            onChangeItem={({ fullStatement, updatedAbbreviatedStatement, humanCodingScheme }) => {
              competencyDocumentItemUpdate({
                variables: {
                  documentId: knowledgeMapItem.documentId,
                  documentItemId: knowledgeMapItem.id,
                  fullStatement,
                  abbreviatedStatement:updatedAbbreviatedStatement,
                  humanCodingScheme,
                },
              });
            }}
          />
        </Paper>
      )}
    </Mutation>
  );

  return isRootNodeSelected ? getMutationForRoot() : getMutationForNonRoot();
}

KnowledgeMapDetailsDrawerContainer.propTypes = {
  knowledgeMap: DocumentShape.isRequired,
};

export default KnowledgeMapDetailsDrawerContainer;
